import { ReactNode } from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import Box from "@mui/material/Box";
import { InputBaseComponentProps } from "@mui/material/InputBase";
import type { SxProps } from "@mui/material/styles";

import InputFormField from "components/input-form-field";

type FirstNameFieldProps = {
  label: string;
  icon?: ReactNode;
  required?: boolean;
  autoFocus?: boolean;
  rules?: any;
  inputProps?: InputBaseComponentProps;
  inputSx?: SxProps;
  sx?: SxProps;
};

type RhfFirstNameFieldProps<T extends FieldValues> = FirstNameFieldProps &
  UseControllerProps<T>;

export default function WizardTextField<T extends FieldValues>({
  control,
  name,
  label,
  icon,
  required,
  autoFocus,
  rules,
  inputProps,
  sx,
  inputSx
}: RhfFirstNameFieldProps<T>) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={sx}
    >
      {Boolean(icon) && icon}
      <InputFormField
        name={name}
        label={label}
        control={control}
        required={required}
        autoFocus={autoFocus}
        rules={rules}
        inputProps={inputProps}
        sx={inputSx ? inputSx : !icon ? { ml: 0 } : undefined}
      />
    </Box>
  );
}
